<template>
  <v-card class="chat-details pt-3 elevation-0">
    <v-layout row wrap class="justify-center align-items-center" px-1 mb-3>
      <v-flex md3>
        <v-layout row wrap justify-center>
          <avatar
            :initials="(chat.customer ? chat.customer.name || chat.customer.first_name || 'd' : chat.user_name || 'd'). charAt(0).toUpperCase()"
            :size="60"
            background-color="#ff7c64"
            color="#fff"
            class="px-2 mt-2 py-0">
          </avatar>
        </v-layout>
      </v-flex>
      <v-flex md5 class="text-capitalize">
        <h2 clas="d-inline-block">
          {{ (chat.customer ? chat.customer.name || chat.customer.first_name  || 'd' : chat.user_name || 'desconocido').toLowerCase() }}
        </h2>
        <small v-if="!chat.customer && chat.user_name">(Desconocido)</small>
      </v-flex>
      <v-flex md2 v-if="chat.customer">
        <v-layout row wrap justify-center>
          <v-tooltip bottom>
            <v-btn icon flat small slot="activator" @click="edit(chat.customer.customer_emails && chat.customer.customer_emails.length ? 'phone' : 'email')">
              <v-icon small>
                fas fa-pencil-alt
              </v-icon>
            </v-btn>
            <span>Editar</span>
          </v-tooltip>
        </v-layout>
      </v-flex>
      <v-flex md2>
        <v-layout row wrap justify-center>
          <v-tooltip bottom>
            <v-btn icon flat small slot="activator" @click="close()">
              <v-icon small>
                fas fa-times
              </v-icon>
            </v-btn>
            <span>Cerrar</span>
          </v-tooltip>
        </v-layout>
      </v-flex>
    </v-layout>
    <template v-if="chat.customer">
      <v-layout row wrap text-xs-center mb-2 mt-4>
        <v-flex :md4="$auth.user().role !== 'agent'" :md6="$auth.user().role === 'agent'">
          <small>Cuenta</small>
          <br>
          {{ chat.customer.account || 'Sin especificar' }}
        </v-flex>
        <v-flex :md4="$auth.user().role !== 'agent'" :md6="$auth.user().role === 'agent'">
          <small>RUT/DNI/CI</small>
          <br>
          {{ chat.customer.fiscal_id || 'Sin especificar' }}
        </v-flex>
        <v-flex md4 v-if="$auth.user().role !== 'agent'">
          <small>Agencia</small>
          <br>
          <template v-if="chat.customer.customer_agency">
            {{ `${chat.customer.customer_agency.name} (${chat.customer.agency})` }}
          </template>
          <template v-else>
            {{ chat.customer.agency || 'Sin especificar' }}
          </template>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 text-xs-center>
          <small>Enviado desde</small>
          <br>
          {{ chat.internal_id }}
        </v-flex>
      </v-layout>
      <br>
      <v-divider inset></v-divider>
      <v-list two-line class="pa-0">
        <template v-if="chat.customer.customer_emails && chat.customer.customer_emails.length">
          <vue-perfect-scrollbar class="chat-details--scrollbar">
            <v-list-tile v-for="email in chat.customer.customer_emails" :key="`email-${email.id}`" @click="edit('email')">
              <v-list-tile-action>
                <v-icon class="k-orange-linear-text">mail</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ email.email }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ email.type }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </vue-perfect-scrollbar>
          <v-divider inset></v-divider>
        </template>
        <v-list-tile @click="movements('notification_schedule')">
          <v-list-tile-action>
            <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Gestiones</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile @click="movements('payment')">
          <v-list-tile-action>
            <v-icon class="k-orange-linear-text">fas fa-hand-holding-usd</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Pagos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <template v-if="chatMovements">
          <v-divider inset></v-divider>
          <v-list-tile @click="showChatMovements()">
            <v-list-tile-action>
              <v-icon class="k-orange-linear-text">fas fa-exchange-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Movimientos</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-divider inset></v-divider>
        <v-list-tile @click="moreDetails()">
          <v-list-tile-action>
            <v-icon class="k-orange-linear-text">fas fa-info-circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Ver más</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </template>
    <template v-else>
      <br>
      <v-divider inset></v-divider>
      <v-list two-line class="pa-0">
        <v-list-tile>
          <v-list-tile-action>
            <v-icon class="k-orange-linear-text">{{ chat.channel === 'email' ? 'mail' : 'phone' }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="user-select-text">{{ chat.internal_id }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ chat.channel === 'email' ? 'Email' : 'Teléfono' }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </template>
    <edit-customer-modal
      v-if="chat.customer && showEdit"
      :customer="chat.customer"
      :show="showEdit" 
      @contact-added="contactAdded"
      @contact-updated="contactUpdated"
      @customer-updated="updateCustomer"
      @close="showEdit = false">
    </edit-customer-modal>
  </v-card>
</template>

<script>
import Vue from 'vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Avatar from 'vue-avatar';
import EventBus from '@/event-bus';
import EditCustomerModal from '@/components/customer/EditCustomerModal';
import EditMethod from '@/components/customer/EditMethod';

export default {
  props: {
    chat: {
      type: Object,
      required: true,
    },
  },
  components: {
    Avatar,
    EditMethod,
    EditCustomerModal,
    VuePerfectScrollbar,
  },
  created() {
    EventBus.$on('chatMovements', (show) => {
      this.chatMovements = show;
    });
    EventBus.$on('edit-phones', () => {
      this.edit('phone');
    });
  },
  destroyed() {
    EventBus.$off('chatMovements');
    EventBus.$off('edit-phones');
  },
  data() {
    return {
      type: 'phone',
      showEdit: false,
      chatMovements: false,
      showEditMethod: false,
    };
  },
  methods: {
    edit(type) {
      this.type = type;
      this.showEdit = true;
    },
    close() {
      this.$emit('close-chat');
    },
    movements(type) {
      EventBus.$emit('showMovements', type, this.chat.customer.id);
    },
    showChatMovements() {
      EventBus.$emit('showChatMovements');
    },
    moreDetails() {
      EventBus.$emit('customerDetailDialog', this.chat.customer);
    },
    contactAdded($event) {
      this.chat.customer[`customer_${$event.type}s`].push($event.value);
    },
    contactUpdated($event) {
      const index = this.chat.customer[`customer_${$event.type}s`].findIndex(item => item.id === $event.value.id);
      this.chat.customer[`customer_${$event.type}s`][index] = $event.value;
      Vue.set(this.chat.customer[`customer_${$event.type}s`][index], index);
    },
    updateCustomer($event) {
      this.chat.customer = $event;
      Vue.set(this.chat.customer);
      this.closeEdit();
      EventBus.$emit('customer-edited', $event);
    },
    closeEdit() {
      this.type = 'phone';
      this.showEdit = false;
    },
  },
};
</script>

<style scoped>
.chat-details {
  height: calc(100vh - 90px - 46px);
}
.chat-details--scrollbar {
  max-height: 83px;
}
.chat-details--scrollbar .list__tile div:not(.list__tile__action) {
  user-select: text !important;
}
</style>


// WEBPACK FOOTER //
// src/components/chat_center/CustomerDetail.vue